import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import Home from '../../../containers/Home';
import animator from '../../../helpers/animator';
import dataModel from '../../../models/DataModel';
import NewProjectTasks from './ProjectTasks';
import Animate from '../../../components/Animate';

// assets
import checkmarkClipboard from '../../../assets/images/task-icon-gray.svg';
import offlineCloudIcon from '../../../assets/images/offline-cloud-double-slash.svg';
import LoadingDots from '../../../components/LoadingDots';
import toggle from '../../../assets/images/ao-toggle-on.png';
import './ProjectsTasksContainer.scss';

class NewProjectsTasksContainer extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();

    this.createTaskList = this.createTaskList.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionCableUpdate != this.props.actionCableUpdate) {
      this.setState({ actionCableUpdate: this.props.actionCableUpdate });
    }
  }

  createProjectList() {
    const { appliedTaskFilters, myProjects, project_id } = this.props;
    let filteredProjects = [];
    for (let project of myProjects) {
      if (project_id && parseInt(project_id, 10) != project.id) {
        continue;
      }
      else if (!project.tasks || !project.tasks.length) {
        continue;
      }
      // TODO: filter out projects for which no tasks match the filters
      if (!filteredProjects.includes(project)) {
        filteredProjects.push(project);
      }
      if (project_id) {
        break; 
      }
    }

    return  filteredProjects && filteredProjects.map(project => {
      let viewTasks = this.createTaskList(project, appliedTaskFilters);
      if (viewTasks.length > 0) {
        return (
          <NewProjectTasks
            key={project.id}
            project={project}
            appliedTaskFilters={appliedTaskFilters}
            viewTasks={viewTasks}
          />
        );
      }
      else {
        return null;
      }
    }).filter(element => { return element != null;});
  }

  createTaskList(project, appliedTaskFilters) {
    let viewTasks = [];
    for (let task of project.tasks) {
      if (task && task.user_task_assignments && (
        !appliedTaskFilters || 
        !appliedTaskFilters.length || 
        appliedTaskFilters.includes(task.status)
      )) {
        viewTasks.push(task);
      }
    }
    return viewTasks;
  }

  async handleScroll(e) {
    const totalScroll = await this.props.handleScroll(e);
    if (totalScroll > 0){
      this.setState({ animateScroll: totalScroll });
    }
  }

  handleAnimationDone(){
    this.setState({ animateScroll: 0 });
  }

  render() {

    let waitSpinner = null;
    if (!this.props.myProjects || this.props.pending == 'pending') {
      waitSpinner = <Home type="transparent" />;
    }

    let animate = null;
    if (this.state.animateScroll){
      let scroller = document.getElementById('project-tasks-scroller');
      animate = <Animate component_id="project-tasks-scroller" duration={300} property={{
        verticalScroll: {
          startVal: scroller ? scroller.scrollTop : 0,
          endVal: scroller ? (scroller.scrollTop + this.state.animateScroll) : 0,
        },
      }} completionCallback={this.handleAnimationDone} />;
    }
    const tasks = this.createProjectList();
    let tasksView;
    if (tasks && tasks.length > 0) {
      tasksView = tasks;
    }
    else if (this.props.online) {
      tasksView = (
        <div className="empty-tasks">
          <img className="empty-tasks__image" src={checkmarkClipboard} alt="empty tasks" />
          <p className="empty-tasks__description">{this.props.pending == 'pending' ? 'Retrieving Tasks Now' : 'No Tasks Found'}</p>
          {!this.props.pending && <p className="empty-tasks__description"></p>}
          {!this.props.pending && <p className="empty-tasks__description2">Looking for something?</p>}
          {!this.props.pending && <p className="empty-tasks__description2">Select &#9733; to Favorite a Project and make it available offline.</p>}
        </div>
      );
    }
    else {
      tasksView = (
        <div className="offline-no-tasks">
          <img className="offline-no-tasks__image" src={offlineCloudIcon} alt="No Internet Connection" />
          <p className="offline-no-tasks__description">Some results may be unavailable in Offline Mode</p>
        </div>
      );
    }
    return (
      <div 
      className="projects-tasks" 
      id="project-tasks-scroller"
      onScroll={this.handleScroll}
      >
      {waitSpinner}
        {animate}
        {tasksView}
        {
          this.props.pending == 'load-more' && <div className='loading-dots-cont'><LoadingDots /></div>
        }
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    actionCableUpdate: state.main.actionCableUpdate,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
    online: state.main.online,
  };
};

export default connect(mapStateToProps)(NewProjectsTasksContainer);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/NewProjectsTasksContainer/index.js